import { useEffect, useState } from "react";
import { CheckCircle, Circle, CreditCard } from "@phosphor-icons/react";
import api from "../../lib/api";
import { Card, Field, Grid, ReadOnlyNote, inputCls, btnPrimary } from "./shared";

export default function PagamentiSection({ settings, onSave, saving, readOnly }) {
  const [p, setP] = useState(settings.pagamenti?.caparra || {});
  const [stripe, setStripe] = useState(null);
  const set = (k, v) => setP({ ...p, [k]: v });

  useEffect(() => {
    api.get("/integrations/services")
      .then((r) => setStripe(r.data.services.find((s) => s.key === "stripe")))
      .catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="setsection-pagamenti">
      <Card title="Metodo di pagamento"
        desc="Pagamenti che il ristorante riceve dai propri clienti (caparre, prepagamenti). La connessione tecnica è gestita da Dishenda; il collegamento diretto al tuo conto bancario sarà disponibile a breve."
        testid="pay-stripe-card">
        <div className="flex items-center gap-3">
          <span className={`w-10 h-10 rounded-lg flex items-center justify-center ${stripe?.attivo ? "bg-emerald-50 text-emerald-600" : "bg-zinc-100 text-zinc-400"}`}>
            <CreditCard size={20} weight="bold" />
          </span>
          <div className="flex-1">
            <div className="text-sm font-bold text-zinc-900">Pagamenti online</div>
            <div className="text-xs text-zinc-500">{stripe?.gestione || "Configurazione gestita da Dishenda"}</div>
          </div>
          {stripe?.attivo ? (
            <span className="text-[10px] font-bold px-2 py-0.5 rounded-full border bg-emerald-100 text-emerald-800 border-emerald-300 flex items-center gap-1" data-testid="pay-status">
              <CheckCircle size={10} weight="fill" /> ATTIVO
            </span>
          ) : (
            <span className="text-[10px] font-bold px-2 py-0.5 rounded-full border bg-zinc-100 text-zinc-500 border-zinc-300 flex items-center gap-1" data-testid="pay-status">
              <Circle size={10} /> NON ATTIVO
            </span>
          )}
        </div>
      </Card>

      <Card title="Caparra / prepagamento"
        desc="Configurazione operativa applicata alle prenotazioni (es. eventi, tavolate)."
        testid="pay-caparra-card">
        <label className="flex items-center gap-2 text-sm text-zinc-700">
          <input type="checkbox" checked={!!p.attiva} onChange={(e) => set("attiva", e.target.checked)}
            className="w-4 h-4 accent-zinc-900" data-testid="pay-caparra-attiva" /> Richiedi caparra
        </label>
        {p.attiva && (
          <>
            <Grid>
              <Field label="Tipo">
                <select value={p.tipo || "fisso"} onChange={(e) => set("tipo", e.target.value)}
                  className={inputCls} data-testid="pay-tipo">
                  <option value="fisso">Importo fisso a prenotazione</option>
                  <option value="per_persona">Importo per persona</option>
                  <option value="percentuale">Percentuale sul conto stimato</option>
                </select>
              </Field>
              <Field label="Importo (€)">
                <input type="number" min="0" value={p.importo ?? 10}
                  onChange={(e) => set("importo", parseFloat(e.target.value) || 0)}
                  className={inputCls} data-testid="pay-importo" />
              </Field>
              <Field label="Quando richiederla">
                <select value={p.quando || "eventi"} onChange={(e) => set("quando", e.target.value)}
                  className={inputCls} data-testid="pay-quando">
                  <option value="sempre">Sempre</option>
                  <option value="eventi">Solo per eventi</option>
                  <option value="soglia">Sopra una soglia di coperti</option>
                  <option value="weekend">Nel weekend</option>
                </select>
              </Field>
            </Grid>
            <Field label="Descrizione mostrata al cliente">
              <textarea value={p.descrizione || ""} onChange={(e) => set("descrizione", e.target.value)}
                rows={2} className={`${inputCls} h-auto py-2`} data-testid="pay-descrizione"
                placeholder="Es. caparra confermatoria detratto dal conto finale…" />
            </Field>
          </>
        )}
      </Card>

      {readOnly ? <ReadOnlyNote /> : (
        <button disabled={saving} onClick={() => onSave({ pagamenti: { caparra: p } })}
          className={btnPrimary} data-testid="pay-save">Salva Pagamenti</button>
      )}
    </div>
  );
}
